import { configureStore } from '@reduxjs/toolkit';
import navigationReducer from '@/store/slices/navigationSlice';
import authReducer from '@/store/authSlice';
import { persistAuthState } from '@/store/authStorage';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    navigation: navigationReducer,
  },
});

store.subscribe(() => {
  persistAuthState(store.getState().auth);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
